import React, { useState, useEffect, useRef } from "react";

export default function APIDocumentation() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const containerRef = useRef(null);

  const loadSwaggerUI = () => {
    if (window.SwaggerUIBundle) {
      initializeSwaggerUI();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://unpkg.com/swagger-ui-dist@5.0.0/swagger-ui-bundle.js";
    script.onload = () => {
      const css = document.createElement("link");
      css.rel = "stylesheet";
      css.href = "https://unpkg.com/swagger-ui-dist@5.0.0/swagger-ui.css";
      document.head.appendChild(css);
      initializeSwaggerUI();
    };
    script.onerror = () => setError("Failed to load Swagger UI");
    document.head.appendChild(script);
  };

  const initializeSwaggerUI = () => {
    if (!containerRef.current) return;

    window.SwaggerUIBundle({
      url: "/api/dashboard/v2/swagger.json",
      dom_id: "#swagger-ui-container",
      deepLinking: false, // Disable deep linking to prevent URL conflicts with React Router
      presets: [window.SwaggerUIBundle.presets.apis, window.SwaggerUIBundle.presets.standalone],
      plugins: [window.SwaggerUIBundle.plugins.DownloadUrl],
      layout: "BaseLayout",
      requestInterceptor: (req) => {
        const token = localStorage.getItem("authToken");
        if (token) {
          req.headers.Authorization = `Bearer ${token}`;
        }
        return req;
      },
      onComplete: () => setLoading(false),
    });
  };

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      if (containerRef.current) {
        loadSwaggerUI();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (error) {
    return (
      <div className="h-100" style={{ overflowY: "auto" }}>
        <div className="container mx-auto p-6">
          <h1 className="text-3xl font-bold mb-6">API Documentation</h1>
          <div className="alert alert-danger">Error: {error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-100" style={{ overflowY: "auto" }}>
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-6">API Documentation</h1>
        {loading && <p>Loading API documentation...</p>}
        <div id="swagger-ui-container" ref={containerRef} style={{ minHeight: "600px", opacity: loading ? 0.5 : 1 }} />
      </div>
    </div>
  );
}
